import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { PickerJobAddEditComponent, PickerJobListComponent, PickerJobScanComponent, PickerJobViewComponent } from '@inventory/components/picker-jobs';
import { PickerSerialnumberViewComponent } from './picker-serialnumber-view/picker-serialnumber-view.component';
import { RouterModule, Routes } from '@angular/router';
import { MatDialogModule, MatTabsModule } from '@angular/material';

const routes: Routes = [
    { path: '', component: PickerJobListComponent, data: { title: 'Picker Job List' } },
    { path: 'add', component: PickerJobAddEditComponent, data: { title: 'Add Picker Jobs' } },
    { path: 'scan', component: PickerJobScanComponent, data: { title: 'Picker Job Scan' } },
    { path: 'view', component: PickerJobViewComponent, data: { title: 'Picker Job View' } }
];
const pickerJobsDeclarationComponents = [
    PickerSerialnumberViewComponent, PickerJobListComponent, PickerJobAddEditComponent, PickerJobScanComponent, PickerJobViewComponent, PickerSerialnumberViewComponent
];
@NgModule({
    declarations: [ ...pickerJobsDeclarationComponents],
    imports: [
        CommonModule,
        LayoutModule,
        MatTabsModule,
        MatDialogModule,
        SharedModule,
        RouterModule.forChild(routes)
    ],
    entryComponents: [
        PickerSerialnumberViewComponent],
})

export class PickerJobsModule { }